import React from 'react';
import styled from 'styled-components';
import { HeaderLogo } from 'styles/Styles.styled';
import logo from 'assets/images/portal-logo.svg';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import EpdRoutes from 'routes/EpdRoutes';
import AuthLayoutFrameFooterResources from './AuthLayoutFrameFooterResources';

const AuthLayoutFrame: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <nav>
        <HeaderLink to={EpdRoutes.login}>
          <HeaderLogo src={logo} alt="EPD International" />
        </HeaderLink>
      </nav>

      {children}

      <Footer>
        {t('footer.text')}
        {' | '}
        <a href={t('footer.link')} target="_blank">
          {t('footer.linkText')}
        </a>
        {' | '}
        <AuthLayoutFrameFooterResources />
      </Footer>
    </Wrapper>
  );
};

export default AuthLayoutFrame;

const Wrapper = styled.div`
  font-family: Inter;
  min-height: 100vh;
  min-height: 100dvh;
  display: grid;
  grid-template-rows: max-content 1fr max-content;
  font-size: 14px;
  color: ${(props) => props.theme.colors.primaryBlack};
`;

const HeaderLink = styled(Link)`
  align-self: flex-start;
`;

const Footer = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 32px;
  padding-bottom: 40px;
  padding-left: 40px;
  padding-right: 40px;
  white-space: pre-wrap;
  &,
  a {
    font-size: 14px;
    color: ${(props) => props.theme.colors.primaryBlack};
  }
`;
